// extracted by mini-css-extract-plugin
export default {"pop_content_wrap":"ForgetPwd_pop_content_wrap__fK7hu","btn_start":"ForgetPwd_btn_start__zOQ9l","animate-rotate":"ForgetPwd_animate-rotate__vxDUQ"};